import { render, staticRenderFns } from "./medicinalSector.vue?vue&type=template&id=1bd9b498&scoped=true&"
import script from "./medicinalSector.vue?vue&type=script&lang=js&"
export * from "./medicinalSector.vue?vue&type=script&lang=js&"
import style0 from "./medicinalSector.vue?vue&type=style&index=0&id=1bd9b498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9b498",
  null
  
)

export default component.exports